import Axios from 'axios'
import {activityContactUrls} from '../urls'
import router from '../../../router'

export default {
  get_all_activity_contacts (context, publicId) {
    Axios.get(activityContactUrls.getAllActivityContact + publicId).then(function (response) {
      context.commit('GET_ALL_ACTIVITY_CONTACTS', response.data)
    })
  },
  get_activity_contacts (context, publicId) {
    Axios.get(activityContactUrls.getAllActivityContact + publicId).then(function (response) {
      context.commit('GET_ACTIVITY_CONTACTS', response.data)
    })
  },
  get_active_contacts (context, publicId) {
    Axios.get(activityContactUrls.getActiveActivityContact + publicId).then(function (response) {
      context.commit('GET_ACTIVITY_CONTACTS', response.data)
    })
  },
  get_in_active_contacts (context, publicId) {
    Axios.get(activityContactUrls.getInActiveActivityContact + publicId).then(function (response) {
      context.commit('GET_ACTIVITY_CONTACTS', response.data)
    })
  },
  get_deleted_activity_contacts (context) {
    Axios.get(activityContactUrls.getDeletedActivityContact).then(function (response) {
      context.commit('GET_DELETED_ACTIVITY_CONTACTS', response.data)
    })
  },
  get_activity_contact (context, publicId) {
    Axios.get(activityContactUrls.getActivityContact + publicId).then(function (response) {
      context.commit('GET_ACTIVITY_CONTACT', response.data)
    })
  },
  post_activity_contact (context, data) {
    Axios.post(activityContactUrls.postActivityContact, data).then(function () {
      context.dispatch('get_activity_contacts', data.inventory_id)
    }).catch(function (error) {
      // console.log(error.data)
    })
  },
  make_activity_contact_active (context, data) {
    Axios.get(activityContactUrls.makeActivityContactActive + data.public_id).then(function () {
      context.commit('GET_ALL_ACTIVITY_CONTACTS', {data: []})
      context.dispatch('get_all_activity_contacts', data.inventory_id)
    }).catch(function (error) {
      // console.log(error.data)
    })
  },
  make_activity_contact_in_active (context, data) {
    Axios.get(activityContactUrls.makeActivityContactInActive + data.public_id).then(function () {
      context.commit('GET_ALL_ACTIVITY_CONTACTS', {data: []})
      context.dispatch('get_all_activity_contacts', data.inventory_id)
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  update_activity_contact (context, data) {
    Axios.post(activityContactUrls.editActivityContact, data)
    
    .then(function () {
      context.dispatch('get_all_activity_contacts')
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  delete_activity_contact (context, data) {
    Axios.post(activityContactUrls.deleteActivityContact + data.public_id, data).then(function () {
      context.dispatch('get_activity_contacts', data.inventory_id)
    })
  },
  restoreActivityContact (context, publicId) {
    Axios.get(activityContactUrls.restoreActivityContact + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_ACTIVITY_CONTACTS', response.data)
      router.push({
        name: 'Module.ActivityContacts'
      })
    })
  }
}
